var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          height: "calc(100vh - 140px)",
          overflow: "auto",
          padding: "10px",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "formDataRef",
            attrs: { "label-position": "top", model: _vm.formData },
          },
          [
            _c(
              "el-card",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c("el-divider", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.basicInformation"))
                      ),
                    ]
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "maxlengthInput",
                            attrs: {
                              label: _vm.$t(
                                "mdfeTranslate.InsuranceCompanyName"
                              ),
                              prop: "name",
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["blur", "change"],
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseInput"
                                ),
                                "show-word-limit": "",
                                maxlength: 100,
                              },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "name", $$v)
                                },
                                expression: "formData.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "CNPJ",
                              prop: "cnpj",
                              rules: [
                                {
                                  required: true,
                                  validator: _vm.checkcnpj,
                                  trigger: ["blur", "change"],
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseInput"
                                ),
                              },
                              model: {
                                value: _vm.formData.cnpj,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "cnpj", $$v)
                                },
                                expression: "formData.cnpj",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c("el-divider", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("mdfeTranslate.ConfigurationInformation"))
                      ),
                    ]
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "maxlengthInput",
                            attrs: {
                              label: _vm.$t("mdfeTranslate.ConfigurationName"),
                              prop: "configName",
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["blur", "change"],
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseInput"
                                ),
                                "show-word-limit": "",
                                maxlength: 100,
                              },
                              model: {
                                value: _vm.formData.configName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "configName", $$v)
                                },
                                expression: "formData.configName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-card",
                  [
                    _vm._l(
                      _vm.formData.policyNumberList,
                      function (item, index) {
                        return _c(
                          "el-row",
                          { key: index, attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("mdfeTranslate.PolicyType"),
                                      prop:
                                        "policyNumberList." + index + ".type",
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t(
                                            "collectionCenter.notNull"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        model: {
                                          value: item.type,
                                          callback: function ($$v) {
                                            _vm.$set(item, "type", $$v)
                                          },
                                          expression: "item.type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.policyTypeOptions,
                                        function (list) {
                                          return _c("el-option", {
                                            key: list.value,
                                            attrs: {
                                              label: list.label,
                                              value: list.value,
                                              disabled: _vm.isOptionDisabled(
                                                list.value,
                                                index
                                              ),
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "maxlengthInput",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.PolicyNumber"
                                      ),
                                      prop:
                                        "policyNumberList." + index + ".number",
                                      rules: [
                                        {
                                          required: true,
                                          validator: _vm.noChinese,
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "collectionCenter.pleaseInput"
                                        ),
                                        "show-word-limit": "",
                                        maxlength: 100,
                                      },
                                      model: {
                                        value: item.number,
                                        callback: function ($$v) {
                                          _vm.$set(item, "number", $$v)
                                        },
                                        expression: "item.number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.formData.policyNumberList.length > 1
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-top": "28px",
                                            },
                                            attrs: {
                                              type: "danger",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deletePolicy(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("basicData.Delete"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.addPolicy },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Add")))]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-card",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c("el-divider", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("mdfeTranslate.AdvancedSettings")))]
                  ),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _vm.editType === 2
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("collectionCenter.ifUse"),
                                  prop: "state",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.notNull"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-color": "#ff4949",
                                    "inactive-color": "#13ce66",
                                    "active-text": _vm.$t(
                                      "GlobalSetObj.disable"
                                    ),
                                    "inactive-text": _vm.$t(
                                      "collectionCenter.enable"
                                    ),
                                    "active-value": 0,
                                    "inactive-value": 1,
                                  },
                                  model: {
                                    value: _vm.formData.state,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "state", $$v)
                                    },
                                    expression: "formData.state",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("customerManagements.genterTiem"),
                              prop: "effectiveTime",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "datetime",
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.formData.effectiveTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "effectiveTime", $$v)
                                },
                                expression: "formData.effectiveTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "maxlengthInput",
                            attrs: { label: _vm.$t("collectionCenter.Note") },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "textarea",
                                rows: 6,
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseInput"
                                ),
                                "show-word-limit": "",
                                maxlength: 500,
                              },
                              model: {
                                value: _vm.formData.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "remark", $$v)
                                },
                                expression: "formData.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "right",
          padding: "20px",
          border: "1px solid #ccc",
        },
      },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.cancelConfiguration(1)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.confirmConfiguration },
          },
          [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }